{
  "buttons": {
    "companies": "Companies",
    "contacts": "Contacts",
    "activities": "Activities"
  },
  "import_components": {
    "imported_file_name": "Imported file name",
    "created_by": "Created by",
    "created_at": "Created at",
    "progress": "Progress",
    "error_importing_data": "Error importing data.",
    "loading": "...",
    "import_in_progress": "Import is in progress, check back in a few minutes."
  }
}
